export default () => "/api/"
